import { Component, inject } from '@angular/core';
import { Location } from '@angular/common';
import { AutofocusComponent } from '../../components/settings/autofocus/autofocus.component';
import { MatFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { SettingsService } from '../../core/services/settings.service';
import { CameraComponent } from '../../components/settings/camera/camera.component';
import packageJson from '../../../../package.json';
import { RedemptionsLogSizeComponent } from '../../components/settings/redemptions-log-size/redemptions-log-size.component';
import { ConfirmDialogComponent } from '../../components/dialog/confirm-dialog/confirm-dialog.component';
import { RedemptionStatusEnum } from '../../core/enums/redemption-status.enum';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-settings',
  imports: [
    AutofocusComponent,
    MatFabButton,
    MatIcon,
    CameraComponent,
    RedemptionsLogSizeComponent,
  ],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss',
})
export class SettingsComponent {
  private settingsService = inject(SettingsService);
  private _location = inject(Location);

  readonly dialog = inject(MatDialog);
  public version: string = packageJson.version;
  reset() {
    this.settingsService.reset();
  }

  backClicked() {
    this._location.back();
  }

  openConfirmResetDialog(context: string): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      enterAnimationDuration: '200ms',
      exitAnimationDuration: '100ms',
      data: {
        context: context,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.settingsService.reset();
      }
    });
  }

  protected readonly RedemptionStatusEnum = RedemptionStatusEnum;
}
